import React from 'react'
import {
  makeStyles,
  createStyles,
  withStyles,
  Drawer,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
  Divider,
} from '@material-ui/core'
import classnames from 'classnames'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
const CustomDrawer = withStyles((theme) => ({
  paperAnchorBottom: {
    left: '30%',
    bottom: '0',
    maxWidth: '40%',
    borderStartEndRadius: theme.spacing(0.75),
    borderStartStartRadius: theme.spacing(0.75),
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4.5),
    [theme.breakpoints.down('xs')]: {
      left: '0',
      bottom: '0',
      maxWidth: 'none',
    },
  },
  paperAnchorRight: {
    width: '30%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}))(Drawer)

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    payingheader: {
      display: 'flex',
      margin: '0 auto',
      fontWeight: theme.typography.fontWeightBold,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    icon: {
      position: 'absolute',
      height: 32,
      right: 16,
    },
    headerFaq: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      margin: '0 auto',
    },

    closeIcon: {
      '& path': {
        stroke: theme.palette.grey[700],
      },
    },
  }),
)

const EDrawer = ({ children, className, title, isCenter, onClose, isOrder, mask, anchor, ...rest }) => {
  const classes = useStyles()
  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <CustomDrawer
      anchor={anchor ? anchor : 'bottom'}
      className={classnames((classes.root, className))}
      onClose={mask ? null : onClose}
      {...rest}
    >
      {isCenter ? (
        <Box position="relative">
          <Typography
            style={{ textAlign: 'center', height: 50, fontWeight: 600 }}
            variant={matches ? 'h3' : 'h5'}
            color="textPrimary"
            noWrap
          >
            {title}
          </Typography>
          <IconButton
            size="small"
            aria-label="close button"
            onClick={onClose}
            style={{ position: 'absolute', top: -2, right: 5 }}
          >
            <CancelOutlinedIcon />
          </IconButton>
        </Box>
      ) : location.pathname.includes('/add-order/paying') ? (
        <Box>
          <Box className={classes.payingheader}>
            <Typography className={classes.title} variant={matches ? 'h3' : 'h5'} color="textPrimary" noWrap>
              {title}
            </Typography>
            <IconButton size="small" aria-label="close button" onClick={onClose} className={classes.icon}>
              <CancelOutlinedIcon />
            </IconButton>
          </Box>
          <Divider />
        </Box>
      ) : (
        <Box className={isOrder ? classes.headerFaq : classes.header}>
          <Typography className={classes.title} variant={matches ? 'h3' : 'h5'} color="textPrimary" noWrap>
            {title}
          </Typography>
          <IconButton size="small" aria-label="close button" onClick={onClose}>
            <CancelOutlinedIcon />
          </IconButton>
        </Box>
      )}
      {children}
    </CustomDrawer>
  )
}

export default EDrawer
